import React from 'react';

import Box from '@components/Restyle/Box';
import Icon from '@components/shared/Icon/Icon';
import documentIcons from '@themes/documentIcons';
import Images from '@themes/images';
import theme, { getScaledSize } from '@themes/theme';

/**
 * EmailAvatar component
 */
export const EmailAvatar = ({
  width = 40,
  onDismiss,
  icon,
}: {
  width?: 56 | 48 | 40 | 16 | 24 | 32;
  onDismiss?: () => void;
  icon?: keyof typeof Images | keyof typeof documentIcons;
}) => {
  const iconPixelSize = () => {
    switch (width) {
      case 56:
        return 32;
      case 48:
        return 28;
      case 40:
        return 24;
      case 32:
        return 20;
      case 24:
        return 16;
      default:
        return 10;
    }
  };

  const scaledIconSize = getScaledSize(iconPixelSize());

  return (
    <Box paddingTop={onDismiss ? 'xxs' : 'none'}>
      <Box
        width={getScaledSize(width)}
        height={getScaledSize(width)}
        style={{ borderRadius: getScaledSize(width) / 2 }}
        borderRadius='xs'
        backgroundColor='grey02'
        alignItems='center'
        justifyContent='center'>
        <Icon
          color='grey04'
          width={scaledIconSize}
          height={scaledIconSize}
          name={icon ?? 'Mail'}
        />
        {!!onDismiss && (
          <Box
            style={{
              position: 'absolute',
              top: -theme.spacing.xxs,
              right: -theme.spacing.xs,
            }}>
            <Icon
              name='X2'
              onPress={onDismiss}
              color='black'
              variant='l'
              accessibilityLabel='Remove selected member'
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
